import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Loading from '@components/Loading';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import AttendanceNote from './components/AttendanceNote';
import EventContent from './components/EventContent';
import EventFooter from './components/EventFooter';
import EventHeader from './components/EventHeader';
import Sheet from './components/Sheet';
import StampPanel from './components/StampPanel';
import useEvent from './hooks/useEvent';

interface Params {
    eventId: string;
}

const EventActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { eventId } = params;
    const event = useEvent(eventId);
    const { t } = useTranslation('event');
    return (
        <AppScreen >
            <CtaLayout header={<Header title={t('header.title')}/>}
                footer={<EventFooter eventId={eventId}/>} >
                {event ? (
                    <Fragment>
                        <EventHeader event={event}/>
                        <Container spacing={8} fullWidth>
                            <Sheet eventId={eventId} />
                            <StampPanel eventId={eventId} />
                            <EventContent event={event}/>
                            <AttendanceNote eventId={eventId} />
                        </Container>
                    </Fragment>
                ) : (<Loading/>)}
            </CtaLayout>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding-bottom: 64px;
`;

export default EventActivity;
